import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ModulosBuscaService } from 'src/app/shared/components/filtros-busca/service/modulos-service/modulos.service';


@Component({
  selector: 'app-bloco-buscas',
  templateUrl: './bloco-buscas.component.html',
  styleUrls: ['./bloco-buscas.component.scss'],
  standalone: true,
})
export class BlocoBuscasComponent {

  @Input() menuModules: any;             
  @Output() closeBuscas = new EventEmitter<void>(); 

  constructor(
    private router: Router,
    private modulosService: ModulosBuscaService
  ) {}

  getLinkNew(moduloId: number): void {
    const rota = this.modulosService.getRotaById(moduloId);
    if (rota) {
      this.router.navigate([`/buscas/${rota}`]);
      this.closeBuscas.emit(); 
    } else {
      console.warn(`Módulo ID ${moduloId} não encontrado no mapeamento de rotas.`);
    }
  }

  getLinkBuscaSalvas(): void {
    this.router.navigate(['/busca/salvas']);
    this.closeBuscas.emit(); 
  }
}